<template>
    <div class="container">
        <!-- <p>视知觉能力测试</p>
        <p>第8节&nbsp;&nbsp;色觉敏感度测试</p> -->
        <p id="titleTop">视知觉能力测试<span id="titleBottom">&nbsp;---&nbsp;第8节&nbsp;&nbsp;色觉敏感度测试</span></p>
        <img src="../../assets/sejue.png" alt="">
        <p>在本项测试中，屏幕中会出现一些彩色方块，点击选择你认为与其他方块颜色深浅不一样的方块</p>
        <div id="footer">
            <div @click=onTest>试一试</div>
            <div @click=onStart>开始测试</div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'CommonDescription',
        methods:{
            onStart(){
                this.$store.state.global.isTest=false
                this.$router.push('/sejue')
            },
            onTest(){
                this.$store.state.global.isTest=true
                this.$router.push('/sejue')
            }
        },
        mounted(){
            this.$store.state.global.isTrans=true
        }
    }
</script>

<style scoped>
    .container{
        background: rgb(233,233,233);
        position: absolute;
        /* top: 8%; */
        height: 100vw;
        width: 100vh;
        transform-origin: left top;
        transform: rotate(90deg);
        left:100vw;
    }
    span{
        font-weight: bold;
    }
    p{
        text-align: center;
    }
    #titleTop{
        /* padding-top: 3vw; */
        margin-top: 3vw;
        font-size: 5vw;
        font-weight: bold;
    }
    #titleBottom{
        font-size: 5vw;
        font-weight: 200;
    }
    img:nth-child(2){
        width: 40vw;
        position: absolute;
        left:50%;
        top:15%;
        transform:translate(-50%,0%);
    }
    p:nth-child(3){
        font-size: 4vw;
        width: 100vw;
        position: absolute;
        left:50%;
        top:68%;
        transform:translate(-50%,-50%);
        line-height: 5vw;
    }
    #footer{
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        left:50%;
        top:88%;
        transform:translate(-50%,-50%);
    }
    #footer div{
        width: 60vw;
        height: 8vw;
        border-radius: 5vw;
        text-align: center;
        line-height: 8vw;
        font-size: 5vw;
        background: rgb(41,123,255);
        color: white;
        margin-top: 2vw;
    }
    #footer div:nth-child(1){
        background: rgb(254,192,2);
    }
</style>